import "./MosquitoControl.module.css";
import MainNavigation from "@/reusable_sections/Header";
import UnderstandPeopleMasterYourself from "./sections/UnderstandPeopleMasterYourself";
import FaqSection from "./sections/FaqSection";
import JoinThe1220Family from "./sections/JoinThe1220Family";
import Faqaccordion from "./sections/Faqaccordion";
import SystemFooter from "@/reusable_sections/Footer";
export default function MosquitoControlPage() {
  return <div>
      <MainNavigation />
      <UnderstandPeopleMasterYourself />
      <FaqSection />
      <JoinThe1220Family />
      <Faqaccordion />
      <SystemFooter />
    </div>;
}